var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('UploadExcelComponent',{attrs:{"on-success":_vm.handleSuccess,"before-upload":_vm.beforeUpload}}),_vm._v(" "+_vm._s(_vm.$data)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }